export default __webpack_public_path__ + "static/tablocation01-df7296d53ea20783cec00e556d64c12b.png";